import { call, put, takeLatest, delay, select } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

function transformAffiliates(audits) {
    const result = audits.map((element, index) => {
        element.index = index;
        element["agreement-type"] = (element.phi === "t" || element.phi === true) ? "Business Associate" : "Confidentiality";
        element["status"] = element.approved === "2" ? "Approved" : element.approved === "1" ? "Declined" : "Under Review";
        element["audit_status"] = element.audit_complete === "t" ? "Audit complete" : element.token === "" ? "Not sent" : "Audit sent";
        return element;
    });
    return result;
}
const getSelected = state => state.UserOrgSiteReducer.selected;

function* loadAffiliatesSaga({ payload }) {
    try {
        const selected = yield select(getSelected);
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.LOAD_AFFILIATES,
            data: {
                organization: selected.org,
                site: selected.site,
            }
        });
        if (apiResponse.res.data.response === 200) {
            const { data } = apiResponse.res.data;
            yield put({
                type: ActionTypeConstants.LOAD_AFFILIATES_SUCCESS,
                payload: {
                    affiliates: transformAffiliates(data)
                }
            });
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.data.message || "An issue occurred while loading affiliates",
                    color: "danger"
                }
            });
            yield delay(10000);
            yield put({ type: ActionTypeConstants.HIDE_ALERT });    
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "An issue occurred while loading affiliates",
                color: "danger"
            }
        });
        yield delay(10000);
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.LOAD_AFFILIATES, loadAffiliatesSaga);
}
